import React from 'react';
import DayTimeSmall from './DayTimeSmall';

const TypicalDaySmall = () => {
  return (
    <div
      css={{
        paddingLeft: 45,
        paddingBottom: 30,
      }}
    >
      <DayTimeSmall
        title="Cours de soutien"
        text=" Nous proposons occasionnellement des cours de rattrapage (mardi et jeudi) pour revoir les notions de la
            veille. C’est l’occasion de refaire des exercices plus simples."
        startHours="08:00"
        endHours="09:00"
        lineStyled="start"
      />
      <DayTimeSmall
        title="Cours"
        text=" En début de matinée, vous aurez un cours théorique de 1h30 à 2h, pour vous enseigner et
          corriger les exercices de la veille"
        startHours="09:00"
        endHours="13:00"
      />
      <DayTimeSmall
        title="Pause"
        text="Profitez de la pause pour échanger avec votre promo"
        startHours="13:00"
        endHours="14:00"
      />
      <DayTimeSmall
        title="Exercices"
        text="Ensuite, vous réaliserez des exercices, traitant des sujets abordés le matin"
        startHours="14:00"
        endHours="18:00"
      />
      <DayTimeSmall
        title="Exercices / Révisions"
        text="  Vous avez la possibilité de rester le soir pour finir les exercices, revoir les notions
          de la journée et réviser des notions des jours précédents."
        startHours="Après"
        endHours="18:00"
        lineStyled="end"
      />
    </div>
  );
};
export default TypicalDaySmall;
